// 组件对象，大写
import queryToolbar from './queryToolbar.vue'
export default queryToolbar
